<template lang="pug">
div
    v-speed-dial(v-model='fab' top left  direction='right' style="top: 8px; z-index: 10;"  absolute open-on-hover transition='slide-y-reverse-transition')
        template(v-slot:activator)
            v-btn(v-model='fab' color='amber darken-3' dark fab small)
                v-icon(v-if='fab')
                    | mdi-close
                v-icon(v-else)
                    | mdi-swap-horizontal
        template(v-if="!sharedLinkMode")
            v-btn(fab dark small color='blue' :to="{ name: 'root' }")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            v-icon mdi-home-outline
                    span
                        | Home
            v-btn(fab dark small color='green darken-2' @click="alertRulesDialog = true")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            v-icon mdi-alert-box
                    span
                        | Alert Rules
        v-btn(fab dark small color='green darken-2' @click="$refs.cookieSettingsDialog.settingsDialog = true")
            v-tooltip(top)
                template(v-slot:activator='{ on, attrs }')
                    span(v-bind="attrs" v-on="on" role="text")
                        v-icon mdi-cog
                span
                    | Cookie Settings
        template(v-if="!sharedLinkMode")
            v-btn(fab dark small color='blue' @click="$refs.sharedLinkDialog.dialog = true")
                v-tooltip(top)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            v-icon mdi-export-variant
                    span
                        | Shared Link
            v-speed-dial(v-model='viewSelectionFab' direction='bottom' transition='slide-y-transition' open-on-hover)
                template(v-slot:activator)
                    v-btn(fab dark small color='purple')
                        v-icon(v-if='viewSelectionFab')
                            | mdi-close
                        v-icon(v-else)
                            | mdi-menu-down
                v-btn(fab dark small :color="currentTab === 'account-view' ? 'green' : 'blue'" @click="setCurrentTab('account-view')")
                    v-tooltip(left)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-view-dashboard
                        span
                            | Account View
                v-btn(fab dark small :color="currentTab === 'agents-view' ? 'green' : 'blue'" @click="setCurrentTab('agents-view')")
                    v-tooltip(left)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-account-group
                        span
                            | Agents View
                v-btn(fab dark small :color="currentTab === 'teams-view' ? 'green' : 'blue'" @click="setCurrentTab('teams-view')")
                    v-tooltip(left)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-office-building
                        span
                            | Teams View
        template(v-else)
            v-btn(fab dark small :color="currentTab === 'account-view' ? 'green' : 'blue'" @click="setCurrentTab('account-view')")
                v-tooltip(left)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            v-icon mdi-view-dashboard
                    span
                        | Account View
            v-btn(fab dark small :color="currentTab === 'agents-view' ? 'green' : 'blue'" @click="setCurrentTab('agents-view')")
                v-tooltip(left)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            v-icon mdi-account-group
                    span
                        | Agents View
            v-btn(fab dark small :color="currentTab === 'teams-view' ? 'green' : 'blue'" @click="setCurrentTab('teams-view')")
                v-tooltip(left)
                    template(v-slot:activator='{ on, attrs }')
                        span(v-bind="attrs" v-on="on" role="text")
                            v-icon mdi-office-building
                    span
                        | Teams View
    template(v-if="currentTab === 'account-view'")
        v-autocomplete(
            label="Scoped Team"
            v-model="scopeParameters.scopeId"
            :items="dataBank.r_teams"
            style="top: 8px; left: 80px; width: 250px; position: absolute; z-index: 9;"
            :item-text="DataBank.getItemText('teams')"
            :item-value="DataBank.getItemValue('teams')"
            absolute
            dense
            outlined
            hide-details
            clearable
            dark
            color="amber darken-3"
            background-color="#424242"
            @change="onScopedTeamChange"
        )
    template(v-if="currentTab === 'agents-view'")
        v-autocomplete(
            label="View Scope"
            v-model="agentViewScope"
            :items="agentViewScopables"
            style="top: 8px; left: 80px; width: 150px; position: absolute; z-index: 9;"
            @change="onAgentViewScopeChange"
            color="amber darken-3"
            background-color="#424242"
            absolute
            dense
            outlined
            hide-details
            clearable
            dark
        )
        template(v-if="agentViewScope?.length > 0")
            v-autocomplete(
                :label="`Scoped ${agentViewScope}`"
                v-model="agentViewScopeId"
                :items="dataBank[userScopedResourceName]"
                :loading="dataBank[userScopedResourceName + 'IsLoading']"
                :item-text="DataBank.getItemText(userScopedResourceKey)"
                :item-value="DataBank.getItemValue(userScopedResourceKey)"
                style="top: 8px; left: 250px; width: 250px; position: absolute; z-index: 9;"
                @change="onAgentViewScopeIdChange"
                color="amber darken-3"
                background-color="#424242"
                absolute
                dense
                outlined
                hide-details
                clearable
                dark
            )
    AlertRulesDialog(
        v-model="alertRulesDialog"
        :rules="rules"
        :show-snackbar="showSnackbar"
        :reload-rules="getRules"
        @reload-rules="getRules"
    )
    CookieSettingsDialog(
        ref="cookieSettingsDialog"
        :cookie-settings-helper-map="cookieSettingsHelperMap"
        :cookie-settings-object="cookieSettingsObject"
        :is-hidden-activator="true"
        :manual-save="false"
        :show-snackbar="showSnackbar"
        title="Big Board View Settings"
    )
    SharedLinksDialog(
        ref="sharedLinkDialog"
        :account-id=" this.sharedLinkMode ? this.accountId : currentUser.activated_account_id"
        component="big_board"
        :hide-share-button="true"
        :shareable-id=" this.sharedLinkMode ? this.accountId : currentUser.activated_account_id"
        shareable-type="account"
        :auto-create="true"
    )
</template>

<script lang="ts">
import Vue from 'vue';
import VolieState from "@/store";

// Components
import AlertRulesDialog from '@/components/dashboards/big_board/alert_rules/alert_rules_dialog.vue';
import CookieSettingsDialog from "@/components/shared/cookie_settings_dialog.vue";
import SharedLinksDialog from '@/components/shared_links/dialog.vue';

export default Vue.extend({
    beforeCreate() {
        return new DataBank({
            lazyResources: ['organization_users', 'teams'],
        });
    },
    data() {
        return {
            DataBank,
            agentViewScopables: [
                { text: 'Organization', value: 'organization' },
                { text: 'Team',         value: 'team' },
            ],
            agentViewScope: '',
            agentViewScopeId: 0,
            alertRulesDialog: false,
            cookieSettingsHelperMap: [
                { cookieKey: 'v_bb_pause_table_scroll_on_hover',            varKey: 'pauseTableScrollOnHover',          type: 'boolean', label: 'Pause Table Scroll on Hover', },
                { cookieKey: 'v_bb_pause_agent_scroll_on_hover',            varKey: 'pauseAgentScrollOnHover',          type: 'boolean', label: 'Pause Agent Scroll on Hover', },
                { cookieKey: 'v_bb_show_user_card_section',                 varKey: 'showUserCardSection',              type: 'boolean', label: 'Show User Card Section', },
                { cookieKey: 'v_bb_hide_unscoped_agents_in_card_section',   varKey: 'hideUnscopedAgentsInCardSection',  type: 'boolean', label: 'Hide Unscoped Agents in Card Section', },
                { cookieKey: 'v_bb_agent_scroll_speed_multiplier',          varKey: 'agentScrollSpeedMultiplier',       type: 'enum',    label: 'Agent Scroll Speed', enumValues: ['0', '0.5', '1', '1.5', '2'] },
                { cookieKey: 'v_bb_table_scroll_speed_multiplier',          varKey: 'tableScrollSpeedMultiplier',       type: 'enum',    label: 'Table Scroll Speed', enumValues: ['0', '0.5', '1', '1.5', '2'] },
            ],
            fab: false,
            viewSelectionFab: false,
        }
    },
    methods: {
        onAgentViewScopeChange() {
            this.agentViewScopeId = 0;
            this.scopeParameters.scopeType = "agents-view";
        },
        onAgentViewScopeIdChange() {
            this.scopeParameters.scopeType = this.agentViewScope;
            this.scopeParameters.scopeId = this.agentViewScopeId || 0;
        },
        onScopedTeamChange() {
            this.scopeParameters.scopeType = (this.scopeParameters.scopeId > 0) ? 'team_organization' : '';
        },
    },
    computed: {
        currentUser() {
            return VolieState.currentUser();
        },
        homeUrl() {
            return VolieState.baseRailsUrl();
        },
        userScopedResourceName() {
            if (this.agentViewScope === 'organization') {
                return 'r_organizationUsers';
            } else if (this.agentViewScope === 'team') {
                return 'r_teams';
            }

            return '';
        }, 
        userScopedResourceKey() {
            if (this.agentViewScope === 'organization') {
                return 'organization_users';
            } else if (this.agentViewScope === 'team') {
                return 'teams';
            }

            return '';
        }
    },
    components: {
        AlertRulesDialog,
        CookieSettingsDialog,
        SharedLinksDialog,
    },
    props: {
        cookieSettingsObject: {
            type: Object,
            required: true,
        },
        currentTab: {
            type: String,
            required: true,
        },
        getRules: {
            type: Function,
            required: true,
        },
        scopeParameters: {
            type: Object,
            required: true,
        },
        setCurrentTab: {
            type: Function,
            required: true,
        },
        sharedLinkMode: {
            type: Boolean,
            required: true,
        },
        showSnackbar: {
            type: Function,
            required: true,
        },
        rules: {
            type: Array,
            required: false,
        },
    },
    watch: {
        currentTab: {
            handler() {
                this.scopeParameters.scopeId = 0;
                this.scopeParameters.scopeType = '';
            },
            deep: true,
        },
    },
    created() {

    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

::v-deep .v-autocomplete {
    .v-input__control {
        background-color: #424242 !important;
    }
    .v-input__slot {
        background-color: #424242 !important;
    }
    .v-select__selection {
        color: #fff !important;
    }
    .v-input__icon {
        color: rgba(255, 255, 255, 0.7) !important;
    }
    input {
        color: #fff !important;
    }
    fieldset {
        border-color: rgba(255, 255, 255, 0.3) !important;
    }
}

</style>